import React from 'react';
import Logo from './Logo';

const FOOTER_LINKS = [
  ['home',          'Home'],
  ['services',      'Services'],
  ['case-studies',  'Case Studies'],
  ['blog',          'Blog'],
  ['about',         'About'],
  ['how-i-work',    'Pricing'],
  ['contact',       'Contact'],
];

export default function Footer({ onNavigate }) {
  return (
    <footer style={{ background: '#201F1E', padding: '48px' }}>
      <div className="section-pad" style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Top row */}
        <div className="footer-row" style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '40px', gap: '32px' }}>
          <div>
            <div onClick={() => onNavigate('home')} style={{ cursor: 'pointer', marginBottom: '12px' }}>
              <Logo size="sm" variant="dark" />
            </div>
            <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.4)', maxWidth: '280px', lineHeight: 1.7 }}>
              Microsoft Dynamics 365 developer and consultant. Custom plugins, flows, PCF controls, PVA chatbots, and integrations — delivered to enterprise standard.
            </p>
          </div>

          <div style={{ display: 'flex', gap: '48px', flexWrap: 'wrap' }}>
            <div>
              <div style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.3)', marginBottom: '14px' }}>Navigation</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {FOOTER_LINKS.map(([page, label]) => (
                  <button
                    key={page}
                    onClick={() => onNavigate(page)}
                    style={{ fontSize: '13px', color: 'rgba(255,255,255,0.55)', background: 'none', border: 'none', cursor: 'pointer', padding: 0, textAlign: 'left', fontFamily: "'Segoe UI', system-ui, sans-serif", transition: 'color 0.15s' }}
                    onMouseEnter={e => e.target.style.color = '#fff'}
                    onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.55)'}
                  >
                    {label}
                  </button>
                ))}
              </div>
            </div>

            <div>
              <div style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.3)', marginBottom: '14px' }}>Services</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {['Plugin Development', 'PCF Controls', 'Power Automate', 'PVA Chatbots', 'CRM Support', 'Integrations'].map(s => (
                  <button
                    key={s}
                    onClick={() => onNavigate('services')}
                    style={{ fontSize: '13px', color: 'rgba(255,255,255,0.55)', background: 'none', border: 'none', cursor: 'pointer', padding: 0, textAlign: 'left', fontFamily: "'Segoe UI', system-ui, sans-serif", transition: 'color 0.15s' }}
                    onMouseEnter={e => e.target.style.color = '#fff'}
                    onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.55)'}
                  >
                    {s}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom row */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: '24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
          <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.25)' }}>
            © {new Date().getFullYear()} AdjustD365 — All rights reserved
          </div>
          <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.25)' }}>
            Microsoft Dynamics 365 Developer & Consultant
          </div>
        </div>
      </div>
    </footer>
  );
}
